const _temp0 = require("../mod_icons/battering_ram.png");
const _temp1 = require("../mod_icons/bribe.png");
const _temp2 = require("../mod_icons/decoy_drop.png");
const _temp3 = require("../mod_icons/drifter.png");
const _temp4 = require("../mod_icons/ecm.png");
const _temp5 = require("../mod_icons/fan_favourite.png");
const _temp6 = require("../mod_icons/front_runner.png");
const _temp7 = require("../mod_icons/iron_fist.png");
const _temp8 = require("../mod_icons/jump_the_gun.png");
const _temp9 = require("../mod_icons/laser_sight.png");
const _temp10 = require("../mod_icons/last_gasp.png");
const _temp11 = require("../mod_icons/magnetic_field.png");
const _temp12 = require("../mod_icons/mastermine.png");
const _temp13 = require("../mod_icons/placeholder.png");
const _temp14 = require("../mod_icons/safety_net.png");
const _temp15 = require("../mod_icons/scrambler.png");
const _temp16 = require("../mod_icons/shielded_bay.png");
const _temp17 = require("../mod_icons/shielded_boosters.png");
const _temp18 = require("../mod_icons/shielding_efficency.png");
const _temp19 = require("../mod_icons/showy_flourish.png");
const _temp20 = require("../mod_icons/silent_running.png");
const _temp21 = require("../mod_icons/splash_damage.png");
const _temp22 = require("../mod_icons/stable_frame.png");
const _temp23 = require("../mod_icons/titanium_armor.png");
const _temp24 = require("../mod_icons/vampiric_wreck.png");
module.exports = {
  "battering_ram": _temp0,
  "bribe": _temp1,
  "decoy_drop": _temp2,
  "drifter": _temp3,
  "ecm": _temp4,
  "fan_favourite": _temp5,
  "front_runner": _temp6,
  "iron_fist": _temp7,
  "jump_the_gun": _temp8,
  "laser_sight": _temp9,
  "last_gasp": _temp10,
  "magnetic_field": _temp11,
  "mastermine": _temp12,
  "placeholder": _temp13,
  "safety_net": _temp14,
  "scrambler": _temp15,
  "shielded_bay": _temp16,
  "shielded_boosters": _temp17,
  "shielding_efficency": _temp18,
  "showy_flourish": _temp19,
  "silent_running": _temp20,
  "splash_damage": _temp21,
  "stable_frame": _temp22,
  "titanium_armor": _temp23,
  "vampiric_wreck": _temp24
}